import { Theme, Users } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import Button from "../components/Button";
import Column from "../components/Column";
import Container from "../components/Container";
import Logo from "../components/Logo";
import ResetButton from "../components/ResetButton";
import Row from "../components/Row";
import Title from "../components/Title";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import { navigateToNext, NavigateToNext, setUserValue, SetUserValue } from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";

interface ICustomerTypeDispatchProps {
  onNavigateToNext: NavigateToNext;
  onSetUserValue: SetUserValue;
}

type CustomerTypeOwnProps = RouteComponentProps;

interface ICustomerTypeStateProps {
  languageStrings: IStrings;
  theme: Theme.Props;
  user: Users.User;
}

type CustomerTypeProps = ICustomerTypeDispatchProps & CustomerTypeOwnProps & ICustomerTypeStateProps;

const CustomerTypeContainer = styled(Container)`
  grid-template-rows: 20vh 55vh 25vh;
`;

const DisclaimerText = styled("div")`
  color: ${(props: { color: string }) => props.color};
  text-shadow: 1px 1px 1px black;
  font-size: 14px;
  width: 400px;
`;

class CustomerType extends React.Component<CustomerTypeProps> {
  public handleEnter = (optIn) => {
    const { onNavigateToNext, onSetUserValue } = this.props;

    onSetUserValue({ name: "customerType", value: optIn });

    onNavigateToNext();
  };

  public render() {
    const {
      languageStrings: strings,
      theme: { colors, logo },
      site: { kioskUiBackgroundColor, kioskUiTitleTextColor, kioskUiButtonSuccessColor },
    } = this.props;

    return (
      <ErrorBoundary>
        <CustomerTypeContainer style={{ background: kioskUiBackgroundColor }}>
          <Row align="center" justify="center">
            <Logo logo={logo} />
          </Row>
          <Column align="center" justify="space-around">
            <Title color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary} size="3rem">
              {strings.typeHeader}
            </Title>
            <Row align="center" justify="center">
              <Button
                bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("fixingCar")}
              >
                {strings.typeFixingCar}
              </Button>
              <Button
                bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("mechanic")}
              >
                {strings.typeMechanic}
              </Button>
              <Button
                bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("bodyMan")}
              >
                {strings.typeBodyMan}
              </Button>
              <Button
                bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("exporter")}
              >
                {strings.typeExporter}
              </Button>
            </Row>
            <Row align="center" justify="center">
              <Button
                bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("ownGarage")}
              >
                {strings.typeOwnGarage}
              </Button>
              <Button
                bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("ownBodyShop")}
              >
                {strings.typeOwnBodyShop}
              </Button>
              <Button
                bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("ownCarLot")}
              >
                {strings.typeOwnCarLot}
              </Button>
              <Button
                bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("buildCustomCars")}
              >
                {strings.typeBuildCustomCars}
              </Button>
            </Row>
          </Column>
          {/* <Row align="center" justify="center">
            <ResetButton />
          </Row> */}
        </CustomerTypeContainer>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = ({ router: { languageStrings }, theme, user }: IState) => ({
  languageStrings,
  theme,
  user,
});

const mapDispatchToProps = {
  onNavigateToNext: navigateToNext,
  onSetUserValue: setUserValue,
};

export default connect<ICustomerTypeStateProps, ICustomerTypeDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(CustomerType);



// WEBPACK FOOTER //
// ./src/views/CustomerType.tsx